export default {
	accessToken: 'stashAccessToken',
	refreshToken: 'stashRefreshToken',
	uuid: 'stashUUID',
} as const;
